// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ck-content .image>figcaption{\n  display:table-caption;\n  caption-side:bottom;\n  word-break:break-word;\n  color:#333;\n  font-size:.75em;\n  outline-offset:-1px\n}[dir] .ck-content .image>figcaption{\n  background-color:#f7f7f7;\n  padding:.6em\n}", ""]);
// Exports
module.exports = exports;
